module.exports = __webpack_public_path__ + "img/Rolandskvadet_Grandes_chroniques_de_France.a2895986.jpg";